"use client";

import { c as _c } from "react/compiler-runtime";
import { useFilter } from "@/components/filters/filter-context";
import { ControlGroup, ControlGroupItem } from "@/components/ui/control-group";
import { InputBase, InputBaseControl, InputBaseInput } from "@/components/ui/input-base";
import { useCallback, useMemo, useState } from "react";
import { z } from "zod";
export interface NumberRange {
  min?: number | undefined;
  max?: number | undefined;
}
export interface NumberRangeFilterProps {
  id: string;
  minPlaceholder?: string;
  maxPlaceholder?: string;
  defaultMin?: number;
  defaultMax?: number;
  step?: number;
  onChange?: (values: NumberRange) => void;
  errorMessage?: string;
}
const rangeSchema = z.object({
  min: z.number().nonnegative().optional(),
  max: z.number().nonnegative().optional()
}).refine(data => !data.min || !data.max || data.max >= data.min, {
  path: ["max"]
});
export function NumberRangeFilter(t0) {
  const $ = _c(41);
  const {
    id,
    minPlaceholder: t1,
    maxPlaceholder: t2,
    defaultMin,
    defaultMax,
    step: t3,
    onChange,
    errorMessage: t4
  } = t0;
  const minPlaceholder = t1 === undefined ? "M\xEDnimo" : t1;
  const maxPlaceholder = t2 === undefined ? "M\xE1ximo" : t2;
  const step = t3 === undefined ? 1 : t3;
  const errorMessage = t4 === undefined ? "El valor m\xE1ximo debe ser mayor o igual que el m\xEDnimo" : t4;
  const {
    getFilterValues,
    setFilterValues,
    registerDefaultValue
  } = useFilter();
  const minId = `${id}_min`;
  const maxId = `${id}_max`;
  registerDefaultValue(minId, defaultMin ? [defaultMin.toString()] : []);
  registerDefaultValue(maxId, defaultMax ? [defaultMax.toString()] : []);
  let t5;
  if ($[0] !== getFilterValues || $[1] !== minId) {
    t5 = getFilterValues(minId);
    $[0] = getFilterValues;
    $[1] = minId;
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  const minValues = t5;
  let t6;
  if ($[3] !== getFilterValues || $[4] !== maxId) {
    t6 = getFilterValues(maxId);
    $[3] = getFilterValues;
    $[4] = maxId;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  const maxValues = t6;
  const min = minValues.length > 0 && minValues[0] !== "" ? Number(minValues[0]) : undefined;
  const max = maxValues.length > 0 && maxValues[0] !== "" ? Number(maxValues[0]) : undefined;
  let t7;
  if ($[6] !== max || $[7] !== min) {
    t7 = {
      min,
      max
    };
    $[6] = max;
    $[7] = min;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  const values = t7;
  const [error, setError] = useState(null);
  let t8;
  if ($[9] !== errorMessage) {
    t8 = (minValue, maxValue) => {
      const result = rangeSchema.safeParse({
        min: minValue,
        max: maxValue
      });
      return result.success ? null : errorMessage;
    };
    $[9] = errorMessage;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  const validateRange = t8;
  let t9;
  if ($[11] !== minId || $[12] !== onChange || $[13] !== setFilterValues || $[14] !== validateRange || $[15] !== values.max) {
    t9 = e => {
      const minValue_0 = e.target.value === "" ? undefined : Number(e.target.value);
      const newError = validateRange(minValue_0, values.max);
      setFilterValues(minId, minValue_0 !== undefined ? [minValue_0.toString()] : []);
      setError(newError);
      if (!newError && onChange) {
        onChange({
          min: minValue_0,
          max: values.max
        });
      }
    };
    $[11] = minId;
    $[12] = onChange;
    $[13] = setFilterValues;
    $[14] = validateRange;
    $[15] = values.max;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  const handleMinChange = t9;
  let t10;
  if ($[17] !== maxId || $[18] !== onChange || $[19] !== setFilterValues || $[20] !== validateRange || $[21] !== values.min) {
    t10 = e_0 => {
      const maxValue_0 = e_0.target.value === "" ? undefined : Number(e_0.target.value);
      const newError_0 = validateRange(values.min, maxValue_0);
      setFilterValues(maxId, maxValue_0 !== undefined ? [maxValue_0.toString()] : []);
      setError(newError_0);
      if (!newError_0 && onChange) {
        onChange({
          min: values.min,
          max: maxValue_0
        });
      }
    };
    $[17] = maxId;
    $[18] = onChange;
    $[19] = setFilterValues;
    $[20] = validateRange;
    $[21] = values.min;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  const handleMaxChange = t10;
  const t11 = values.min ?? "";
  let t12;
  if ($[23] !== handleMinChange || $[24] !== minPlaceholder || $[25] !== step || $[26] !== t11) {
    t12 = <ControlGroupItem><InputBase className="w-1/2"><InputBaseControl><InputBaseInput type="number" placeholder={minPlaceholder} min={0} step={step} value={t11} onChange={handleMinChange} /></InputBaseControl></InputBase></ControlGroupItem>;
    $[23] = handleMinChange;
    $[24] = minPlaceholder;
    $[25] = step;
    $[26] = t11;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  const t13 = values.max ?? "";
  let t14;
  if ($[28] !== handleMaxChange || $[29] !== maxPlaceholder || $[30] !== step || $[31] !== t13) {
    t14 = <ControlGroupItem><InputBase className="w-1/2"><InputBaseControl><InputBaseInput type="number" placeholder={maxPlaceholder} min={0} step={step} value={t13} onChange={handleMaxChange} /></InputBaseControl></InputBase></ControlGroupItem>;
    $[28] = handleMaxChange;
    $[29] = maxPlaceholder;
    $[30] = step;
    $[31] = t13;
    $[32] = t14;
  } else {
    t14 = $[32];
  }
  let t15;
  if ($[33] !== t12 || $[34] !== t14) {
    t15 = <ControlGroup>{t12}{t14}</ControlGroup>;
    $[33] = t12;
    $[34] = t14;
    $[35] = t15;
  } else {
    t15 = $[35];
  }
  let t16;
  if ($[36] !== error) {
    t16 = error && <p className="mt-1 text-xs text-red-500">{error}</p>;
    $[36] = error;
    $[37] = t16;
  } else {
    t16 = $[37];
  }
  let t17;
  if ($[38] !== t15 || $[39] !== t16) {
    t17 = <div>{t15}{t16}</div>;
    $[38] = t15;
    $[39] = t16;
    $[40] = t17;
  } else {
    t17 = $[40];
  }
  return t17;
}